import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "treebal-check" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["filters", {
      checked: _ctx.stateValue === 1,
      unchecked: _ctx.stateValue === 2,
    }]),
    title: _ctx.title,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeState && _ctx.changeState(...args)))
  }, _hoisted_3, 10, _hoisted_1))
}